import { createQueryHook } from "@accurx/api/QueryClient";
import { GetContactsResponse } from "@accurx/api/clinician-messaging";
import { toQueryString } from "@accurx/api/util/query-string";
import { httpClient2 } from "@accurx/shared";

type DirectorySearchQueryVariables = {
    workspaceId: number;
    limit?: number;
    sortBy?: "Distance" | "MessageFrequency";
    searchTerm?: string;
};

export const DirectorySearchQueryKey = "DirectorySearchQuery";

export const useDirectorySearchQuery = createQueryHook<
    DirectorySearchQueryVariables,
    Pick<GetContactsResponse, "contacts" | "searchTermValidity">
>(({ workspaceId, searchTerm, limit, sortBy }) => ({
    queryKey: [
        DirectorySearchQueryKey,
        { workspaceId, searchTerm, limit, sortBy },
    ],
    queryFn: async () => {
        const { contacts, searchTermValidity } = await httpClient2
            .get({
                path: "/api/clinicianmessaging/directory/:workspaceId/contacts",
                params: { workspaceId },
                query: toQueryString({
                    sortBy,
                    limit,
                    searchTerm,
                }),
            })
            .json<GetContactsResponse>();

        return { contacts, searchTermValidity };
    },
}));
